import { kebabCase } from "lodash";

const transformers = {
  color: "getColor",
  backgroundColor: "getColor",
  borderColor: "getColor",
  borderTopColor: "getColor",
  borderRightColor: "getColor",
  borderBottomColor: "getColor",
  borderLeftColor: "getColor",
  outlineColor: "getColor",
  padding: "getLength",
  paddingTop: "getLength",
  paddingRight: "getLength",
  paddingBottom: "getLength",
  paddingLeft: "getLength",
  paddingBlock: "getLength",
  paddingBlockStart: "getLength",
  paddingBlockEnd: "getLength",
  paddingInline: "getLength",
  paddingInlineStart: "getLength",
  paddingInlineEnd: "getLength",
  margin: "getLength",
  marginTop: "getLength",
  marginRight: "getLength",
  marginBottom: "getLength",
  marginLeft: "getLength",
  marginBlock: "getLength",
  marginBlockStart: "getLength",
  marginBlockEnd: "getLength",
  marginInline: "getLength",
  marginInlineStart: "getLength",
  marginInlineEnd: "getLength",
  borderWidth: "getLength",
  borderTopWidth: "getLength",
  borderRightWidth: "getLength",
  borderBottomWidth: "getLength",
  borderLeftWidth: "getLength",
  borderBlockWidth: "getLength",
  borderBlockStartWidth: "getLength",
  borderBlockEndWidth: "getLength",
  borderInlineWidth: "getLength",
  borderInlineStartWidth: "getLength",
  borderInlineEndWidth: "getLength",
  outlineWidth: "getLength",
  outlineOffset: "getLength",
  borderRadius: "getLength",
  borderTopLeftRadius: "getLength",
  borderTopRightRadius: "getLength",
  borderBottomRightRadius: "getLength",
  borderBottomLeftRadius: "getLength",
  borderStartStartRadius: "getLength",
  borderStartEndRadius: "getLength",
  borderEndStartRadius: "getLength",
  borderEndEndRadius: "getLength",
  fontSize: "getFontSize",
  lineHeight: "getFontSize",
};

function findTransformerForCustomProp(key) {
  findTransformerForCustomProp.cache = findTransformerForCustomProp.cache || {};
  if (findTransformerForCustomProp.cache[key]) {
    return findTransformerForCustomProp.cache[key];
  }
  let property = Object.keys(transformers).find((property) => {
    // Matches --color, --icon-color, etc.
    if (key.endsWith("-" + kebabCase(property))) {
      return true;
    }
  });
  let transformer = property && transformers[property];
  findTransformerForCustomProp.cache[key] = transformer;
  return transformer;
}

export default function parseStyle(style, theme) {
  if (!style) return null;
  let parsedStyle = {};
  Object.entries(style).forEach(([key, value]) => {
    let transformerName = key.startsWith("--")
      ? findTransformerForCustomProp(key)
      : transformers[key];
    let transformer = transformerName && theme[transformerName];
    if (transformer) {
      parsedStyle[key] = transformer(value);
    } else if (value == null) {
      // Skip null and undefined values
    } else if (typeof value === "object") {
      parsedStyle[key] = parseStyle(value, theme);
    } else {
      parsedStyle[key] = value;
    }
  });
  return parsedStyle;
}
